import { useTranslation } from "react-i18next";
import { PiMouseLeftClickFill } from "react-icons/pi";
import Key from "./Key";

function Help() {
    const { t } = useTranslation();

    return (
        <div className="help">
            <h3>{t('help.controls')}</h3>
            <p>{t('help.move')} &nbsp; <Key label="W" />, <Key label="A" />, <Key label="S" />, <Key label="D" /></p>
            <p>{t('help.sprint')} &nbsp; <Key label="Shift" /> + <Key label={t('help.move')} /></p>
            <p>{t('help.jump')} &nbsp; <Key label="Space" /></p>
            <p>{t('help.spell')} &nbsp; <PiMouseLeftClickFill className="key-icon" /></p>
            <p>{t('help.settings')} &nbsp; <Key label="Tab" /></p>
            <p>{t('help.fullScreen')} &nbsp; <Key label="Esc" /></p>
        </div>
    );
}

export default Help;